"use client"

import CTA from "@/components/Category/CTA";
import ToFAQ from "@/components/Category/ToFAQ";
import { site } from "@/data/default";
import { ReactNode } from "react";

export const gensetContents: ReactNode = (
  <>
    <section className="space-y-6">
      <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-200">
        <h2 className="text-2xl font-bold mb-3 leading-snug tracking-tight">
          🔌 Kenapa “Sewa Genset Terdekat” Jadi Kebutuhan Mendesak?
        </h2>
        <p className="text-base leading-relaxed">
          Hidup di era digital tanpa backup daya? Sungguh nekat. Genset bukan lagi pelengkap—tapi penyelamat. Saat PLN tidak bersahabat,
          <strong> sewa genset terdekat </strong> jadi solusi tanpa kompromi. Lokasi dekat = waktu respon cepat.
        </p>
        <p className="text-base mt-3">
          Kita bicara tentang kebutuhan listrik darurat untuk event, proyek, sampai produksi. Tapi... siapa penyedia yang siap kirim dalam hitungan jam?
          Jawabannya bukan yang termurah, tapi yang **terdekat, tercepat, terpercaya**.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Variasi daya */}
        <div className="p-6 bg-gray-50 rounded-xl border border-gray-200">
          <h3 className="text-lg font-semibold mb-2">🔋 Banyak Pilihan Daya: 5 - 200 kVA</h3>
          <p className="text-sm leading-relaxed">
            Genset kecil 5 kVA buat booth? Ada. Genset jumbo 200 kVA buat konser besar²an? Siap!
            <strong> Sewa genset terdekat </strong> itu bukan cuma tentang jarak, tapi tentang kecocokan spek.
          </p>
        </div>

        {/* Area layanan */}
        <div className="p-6 bg-gray-50 rounded-xl border border-gray-200">
          <h3 className="text-lg font-semibold mb-2">🗺️ Area Layanan Terdekat, Armada Standby</h3>
          <p className="text-sm leading-relaxed">
            Unit tersebar strategis di banyak titik. Ketika kamu cari <strong> sewa genset terdekat </strong>, sistem kami langsung deteksi unit paling dekat untuk efisiensi waktu.
          </p>
        </div>

        {/* Fasilitas tambahan */}
        <div className="p-6 bg-gray-50 rounded-xl border border-gray-200">
          <h3 className="text-lg font-semibold mb-2">🔧 Gratis Instalasi & Kabel Power</h3>
          <p className="text-sm leading-relaxed">
            Tanpa biaya tersembunyi. Teknisi langsung turun tangan: dari pasang kabel, setting switch, sampai test load. Kamu tinggal fokus ke acaranya.
          </p>
        </div>

        {/* Teknis + bahan bakar */}
        <div className="p-6 bg-gray-50 rounded-xl border border-gray-200">
          <h3 className="text-lg font-semibold mb-2">⛽ Solar Full Tank & Maintenance Berkala</h3>
          <p className="text-sm leading-relaxed">
            Semua genset kami rawat rutin. Gak ada istilah mesin ngadat. <strong>Sewa genset terdekat</strong> kami datang dalam kondisi siap kerja, oli oke, aki segar, solar full.
          </p>
        </div>
      </div>

      <div className="bg-white rounded-2xl p-6 shadow-md border border-gray-200">
        <h2 className="text-xl font-bold mb-3">💸 Harga Sewa Genset Terdekat? Masih Bisa Nego</h2>
        <p className="text-base leading-relaxed">
          Kami paham: tiap proyek beda kebutuhan. Mau sewa harian, mingguan, atau bulanan, semua bisa diatur.
          Mulai dari genset kecil buat warung kopi sampai genset silent buat wedding elegant, <strong>harga sewa genset</strong> kami fleksibel & manusiawi.
        </p>
      </div>

      <div className="bg-white rounded-2xl p-6 shadow-md border border-gray-200">
        <h2 className="text-xl font-bold mb-3">🧠 Bukan Sekadar Mesin. Ini Soal Keamanan & Ketenangan</h2>
        <p className="text-base leading-relaxed">
          Kami nggak jualan mesin, kami tawarkan ketenangan. Di balik setiap <strong>sewa genset terdekat</strong>, ada teknisi kami yang standby,
          memastikan voltase stabil, suara mesin halus, dan aliran daya lancar.
        </p>
        <p className="text-base mt-2">
          Bahkan saat kamu nggak ngerti switch mana harus ditekan, kami sudah siapkan semua supaya kamu tinggal jalankan acara tanpa stres.
        </p>
      </div>

      <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-lg">
        <p className="text-sm italic">
          Ssst... klien kami yang repeat order bukan karena iklan. Tapi karena pengalaman. <br />
          Mereka pernah panik karena blackout, lalu lega karena kami datang cepat. Sekarang? Mereka nggak cari yang lain².
        </p>
      </div>
    </section>

    <CTA
      title="Siap Buat Tempatmu Menyala Bosku?"
      description="🚚 Butuh sewa genset terdekat sekarang juga? Chat tim kami sekarang. <br />Kapan pun, di mana pun, selama unit ready, kami kirim hari itu juga."
      buttonText="Booking Genset Sekarang"
      onClick={() => {
        window.open(
          `https://wa.me/${site.whatsapp}?text=Halo%2C%20saya%20ingin%20booking%20genset.%20Lokasi%20dan%20tanggal%20sudah%20siap.`,
          "_blank"
        );
      }}
    />

    <ToFAQ
      category="Genset"
    />
  </>
);